import React, { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";

import AccountingApi from "../../../Classes/API/AccountingApi";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import SessionsApi from "../../../Classes/API/Administration/SessionsApi";
import searchSessionsReq from "../../../Classes/Models/Requests/Administration/CreateSessionReq";
import AddExtraAccountingSessionToStayReq from "../../../Classes/Models/Requests/Accounting/AddExtraAccountingSessionToStayReq";
import { CardHeader } from "@mui/material";

const AddSessionToStay = ({ setShowAddSession, Stay, setIsLoaded }) => {
  const [Quantity, setQuantity] = useState(1);
  const [FinalPrice, setFinalPrice] = useState(0);
  const [SessionsSearch, setSessionsSearch] = useState();
  const [Session, setSession] = useState({});

  const GetSessions = async () => {
    let searchReq = new searchSessionsReq();

    searchReq.ContractId = Stay.getPatient.contractId;

    searchReq.Name = SessionsSearch;
    searchReq.SecretName = SessionsSearch;

    console.log(searchReq);

    let res = await SessionsApi.SearchSessions(searchReq);

    if (res.status == "Success") {
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item, label: item.name });
      });
      return optionsArr;
    }
  };

  const AddSession = async () => {
    Swal.fire({
      icon: "info",
      title: "Loading",
      text: "Please wait...",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: async () => {
        Swal.showLoading();
      },
    });
    if (Object.keys(Session).length < 1) {
      Swal.fire({
        title: "Error",
        text: "Please select a session",
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    if (Quantity < 1) {
      Swal.fire({
        title: "Error",
        text: "Please select a quantity",
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
      return;
    }
    let req = new AddExtraAccountingSessionToStayReq();
    req.domesticStayId = Stay.id;
    req.sessionId = Session.id;
    req.finalPrice = FinalPrice;
    req.quantity = Quantity;

    let res = await AccountingApi.AddExtraAccountingSessionToDomesticStay(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Session added to stay",
        icon: "success",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
        didOpen: async () => {
          Swal.hideLoading();
        },
      });
    }
  };
  return (
    <Card sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em", padding: "1em" }}>
      <MDBox mb={2} pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          Add EXTRA Session to Stay
        </MDTypography>
        <div>
          <MDButton sx={{ margin: "10px" }} color={"success"} onClick={() => AddSession()}>
            Add Extra
          </MDButton>
          <MDButton mr={2} color={"info"} onClick={() => setShowAddSession(false)}>
            Cancel
          </MDButton>
        </div>
      </MDBox>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4">
            <MDInput
              type="number"
              sx={{ width: "100%" }}
              defaultValue={FinalPrice}
              onChange={(e) => setFinalPrice(e.target.value)}
              label="Session Final Price"
              name="sessionQuantity"
              id="sessionQuantity"
            />
          </div>

          <div className="col-md-4">
            <MDInput
              type="number"
              sx={{ width: "100%" }}
              defaultValue={Quantity}
              onChange={(e) => setQuantity(e.target.value)}
              label="Quantity"
              name="sessionQuantity"
              id="sessionQuantity"
            />
          </div>

          <div className="col-md-4">
            <MDTypography variant="button" fontWeight="regular" color="text">
              <AsyncSelect
                isClearable={true}
                placeholder={"Select Session"}
                loadOptions={GetSessions}
                onInputChange={setSessionsSearch}
                onChange={(e) => setSession(e ? e.value : "")}
                // value={TypeId}
              />
            </MDTypography>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default AddSessionToStay;
